import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import CustomImage from '../images/image'

const RichText = ({ content, className = '' }) => {
  //This custom renderer changes how images are rendered
  //we use it to constrain the max width of an image to its container
  const renderer = ({ alt, src, title }) => (
    <CustomImage alt={alt} src={src} title={title} style={{ maxWidth: '100%' }} />
  )

  return (
    <ReactMarkdown components={{ image: renderer }} className={className}>
      {content}
    </ReactMarkdown>
  )
}

RichText.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.string
  })
}

export default RichText
